import { useLocation, useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { Suspense, createElement, useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  useEffect(() => {
    const isSilkPage = pathname.startsWith('/measurement') || pathname.startsWith('/try-on');
    const pageSurface = pathname === '/' ? 'home' : isSilkPage ? 'silk' : 'default';
    document.body.dataset.pageSurface = pageSurface;

    return () => {
      delete document.body.dataset.pageSurface;
    };
  }, [pathname]);

  return createElement(
    Suspense,
    { fallback: createElement("div", { role: "status", className: "p-8 text-center" }, "VADAURO") },
    element
  );
}
